// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"85fbe8ff","90":"8f79180f","435":"4c2de406","637":"4193a69a","793":"50794dbf","857":"c370174e"}[chunkId] + ".chunk.css";
};